export default __webpack_public_path__ + "static/media/parkshare-house-pink.c84cc883.png";